function ContactForm(id) {
  this.$el = $(id);
  if (this.$el.length < 1) {
    return;
  }

  var prefix = id.substr(1);
  this.$el.on('submit', this.onSubmit.bind(this));
  this.$content = this.$el.find('.' + prefix + '-content');
  this.$confirmation = this.$el.find('.' + prefix + '-confirmation');
  this.$error = this.$el.find('.' + prefix + '-error');
}

ContactForm.prototype.onSubmit = function(evt) {
  function blur() {
    $(evt.target).find('[type="submit"]').blur();
  }

  $.post(this.$el.attr('action'), this.$el.serialize()).then(function () {
    blur();
    this.$content.hide();
    this.$confirmation.show();
  }.bind(this), function(evt) {
    blur();
    this.$error.show();
  }.bind(this));

  return false;
}

new ContactForm('#analysis-form');
new ContactForm('#analysis-content-form');
new ContactForm('#contact-form');

jQuery(function($) {
  $(document).ready(function() {
    if (app.config.isBackend) return

    if (window.matchMedia && window.matchMedia('(min-width: 992px)').matches) {
      $('.nav').sticky({
        topSpacing: 45,
        zIndex: 100
      });
    }
  });
});



// WEBPACK FOOTER //
// ./Private/Scripts/application.js